module.exports = __webpack_public_path__ + "img/calendar-white.2ac53733.svg";